<template>
  <v-select
    v-bind="$attrs"
    v-model="internalValue"
    filled
    :color="primaryColor"
    :items="items"
    item-value="accountId"
    max-height="auto"
    class="transferFunds--custom-textfield"
    :hint="selectedAccountHint"
    persistent-hint
    return-object
   data-qa="paymentsourceselect-select-cb7hr9">
    <template v-slot:selection="data">
      <v-list-item class="pa-0" data-qa="paymentsourceselect-list-item-o6t786">
        {{ formatSelectedAccount(data.item) }}
      </v-list-item>
    </template>
    <template v-slot:item="data">
      <template>
        <v-list-item-content data-qa="paymentsourceselect-list-item-content-n5wxk8">
          {{ formatPrimaryLine(data.item) }}
          <v-list-item-subtitle data-qa="paymentsourceselect-list-item-subtitle-n4z45k"  v-text="formatSecondaryLine(data.item)" />
          <v-divider data-qa="paymentsourceselect-divider-qh0ab"  />
        </v-list-item-content>
      </template>
    </template>
  </v-select>
</template>

<script>
import '@/styles/pages/transferFunds.scss'
import { formatPrimaryLine, formatSecondaryLine, formatSelectedAccount, formatSelectedHint } from '../../util/accountUtil'

export default {
  name: 'PaymentSourceSelect',
  props: {
    value: {
      type: [String, Object, null],
      default: null
    },
    items: {
      type: Array,
      required: true
    }
  },
  inheritAttrs: false, // Prevent automatic inheritance of attributes
  methods: {
    formatPrimaryLine,
    formatSecondaryLine,
    formatSelectedAccount,
    formatSelectedHint
  },
  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value ? {
          ...value,
          selectedAccountText: formatSelectedAccount(value),
          selectedAccountHintText: this.formatSelectedHint(value)
        } : null)
      }
    },
    selectedAccountObj () {
      if (this.internalValue !== null && typeof this.internalValue === 'object') {
        return this.internalValue
      }
      return this.items.find(item => item.accountId === this.internalValue)
    },
    selectedAccountHint () {
      if (!this.selectedAccountObj) return ''
      return formatSelectedHint(this.selectedAccountObj)
    }
  }
}
</script>
